var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUserConnected)?_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.isDisabled,"type":"button"},on:{"click":function($event){return _vm.goToSummary()}}},[_vm._v("\n  Sommaire et résultats\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }